import { createSelector } from 'reselect';

const getActiveViewportIndex = state => state.viewports.activeViewportIndex;
const getLayoutViewports = state => state.viewports.layout.viewports;
const getViewportSpecificData = state => state.viewports.viewportSpecificData;

/**
 * Think of this as a computed getter for our store. It lets us watch parts of
 * our redux state, and only update/recalculate when those values change.
 */
export const getActiveContexts = createSelector(
  [getActiveViewportIndex, getLayoutViewports, getViewportSpecificData],
  (activeViewportIndex, layoutViewports, viewportSpecificData) => {
    const activeContexts = ['VIEWER'];
    const activeLayoutViewport = layoutViewports[activeViewportIndex] || {};
    const activeViewportSpecificData =
      viewportSpecificData[activeViewportIndex] || {};
    const activeViewportPluginName =
      activeLayoutViewport.plugin || activeViewportSpecificData.plugin;

    if (activeViewportPluginName) {
      const activeViewportExtension = `ACTIVE_VIEWPORT::${activeViewportPluginName.toUpperCase()}`;
      activeContexts.push(activeViewportExtension);

      // The vtk extension shares one plugin ('vtk') for both MPR and volume
      // rendering (3D); split them into their own contexts so toolbar buttons
      // (and commands) meant for one don't show up / run in the other.
      if (activeViewportPluginName === 'vtk') {
        const vtkMode = activeLayoutViewport.vtk && activeLayoutViewport.vtk.mode;
        activeContexts.push(
          vtkMode === '3d' ? 'ACTIVE_VIEWPORT::VTK3D' : 'ACTIVE_VIEWPORT::VTKMPR'
        );
      }
    }

    return activeContexts;
  }
);
